exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-bar[data-v-30e6c182]{height:49px;line-height:49px;background:#f5f7fa;border-bottom:1px solid #dfe4ed;position:relative}.title-bar .back-button[data-v-30e6c182]{margin-left:20px}.title-bar .user-info[data-v-30e6c182]{top:0}", ""]);

// exports
